import React from "react";
import ChatHeader from "../ChatLayout/ChatHeader";

const GroupDirectories = ({ memberList, activeChannel, directoryName, currentUserData }) => {
  return (
    <div className="chat-wrapper">
      <div className="chat-main">
        <ChatHeader
          activeChannel={activeChannel}
          memberList={memberList}
          channelName={directoryName}
          currentUserData={currentUserData}
        />
      </div>
    </div>
  );
};

export default GroupDirectories;
